import { TApplicationState } from '../../types/redux';
import { selectFormFields } from '../formFields';
import { selectNewbuildingId } from '../newbuilding';

export const selectNewbuildingFormValues = (state: TApplicationState) => {
  const filters = selectFormFields(state);
  const newBuildingId = selectNewbuildingId(state);

  const { newbuildingSectionsList, newbuildingSection } = filters;

  return {
    newBuildingId,
    area: filters.area as number,
    roomsCount: filters.roomsCount as number,
    newBuildingHouseId: newbuildingSection,
    newbuildingHouse: newbuildingSectionsList?.find(({ value }) => value === newbuildingSection)?.label,
    isNeedChatSubscribe: filters.isChatSubscribeActive,
  };
};
